import _ from "lodash"
import {useCallback, useEffect, useRef} from "react";

export default function useThrottle(cb: any, delay: number) {
    const options = { leading: true, trailing: false };
    const cbRef = useRef(cb);
    useEffect(() => {
        cbRef.current = cb; 
    });
    return useCallback(
        _.throttle((...args: any) => cbRef.current(...args), delay, options),
        [delay]
    );
}